export default __webpack_public_path__ + "static/media/insta.5675bf20.png";